import request from '@/api/axios' // 引入axios文件
// 查询媒体报道
export const userMediaReports = (params) =>
	request({
		url: '/api/userMediaReports',
		method: 'get',
		params: params
	})
// 导出信息
export const download = (params) =>
	request({
		url: '/api/userMatchBasic/download',
		method: 'get',
		responseType: 'blob',
		params
	})
// 下载附件
export const toZipOne = (params) =>
	request({
		url: '/api/userMatchBasic/toZipOne',
		method: 'get',
		responseType: 'blob',
		params
	})
// 批量下载
export const toZip = (params) =>
	request({
		url: '/api/userMatchBasic/toZip',
		method: 'get',
		params
	})
// 插入记录
export const userDownloadRecord = (data) =>
	request({
		url: '/api/userDownloadRecord',
		method: 'post',
		data
	})
// 下载记录
export const userDownloadRecord_get = (params) =>
	request({
		url: '/api/userDownloadRecord',
		method: 'get',
		params
	})
// 新增媒体报道
export const userMediaReportsAdd = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'post',
		data
	})
// 修改媒体报道
export const userMediaReportsEditor = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'put',
		data
	})
// 上传时间列表
export const userMatchTime_get = () =>
	request({
		url: '/api/userMatchTime',
		method: 'get'
	})
// 上传时间列表
export const userMatchTime_get_c = () =>
	request({
		url: '/api/userMatchTime/c',
		method: 'get'
	})
// 编辑
export const userMatchTime_put = (data) =>
	request({
		url: '/api/userMatchTime',
		method: 'put',
		data
	})
// 删除媒体报道
export const userMediaReportsDelete = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'delete',
		data
	})
// 查询成果展示
export const userAchievement = (params) =>
	request({
		url: '/api/userAchievement',
		method: 'get',
		params
	})
// 新增成果展示
export const userAchievementAdd = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'post',
		data
	})
// 修改成果展示
export const userAchievementEditor = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'put',
		data
	})
// 删除成果展示
export const userAchievementDelete = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'delete',
		data
	})
// 用户管理列表
export const queryRegisterUser = (params) =>
	request({
		url: '/api/users/queryRegisterUser',
		method: 'get',
		params
	})
// 修改用户状态
export const updateUserStatus = (data) =>
	request({
		url: '/api/users/updateUserStatus',
		method: 'put',
		data
	})
// 新增用户
export const usersAdd = (data) =>
	request({
		url: '/api/users',
		method: 'post',
		data
	})
// 修改用户
export const usersEdit = (data) =>
	request({
		url: '/api/users',
		method: 'put',
		data
	})
// 修改密码
export const updatePass = (data) =>
	request({
		url: '/api/users/updatePasswordReset',
		method: 'post',
		data
	})
// 报名信息日志 列表
export const userMatchBasic = (params) =>
	request({
		url: '/api/userMatchBasic/getAllMatch',
		method: 'get',
		params
	})
// 详情
export const getMatchById = (params) =>
	request({
		url: '/api/userMatchBasic/getMatchById',
		method: 'get',
		params
	})
// 评审
export const upOrdown = (data) =>
	request({
		url: '/api/userMatchBasic/upOrdown',
		method: 'put',
		data
	})
// 批量审核
export const upOrdownBatch = (data) =>
	request({
		url: '/api/userMatchBasic/upOrdownBatch',
		method: 'put',
		data
	})

// 查看日志
export const userMatchLog = (params) =>
	request({
		url: '/api/userMatchLog',
		method: 'get',
		params
	})
// 信息通知列表
export const userMessage = (params) =>
	request({
		url: '/api/userMessage',
		method: 'get',
		params
	})
// 查了信息详情
export const findByMessageId = (params) =>
	request({
		url: '/api/userMessage/findByMessageId',
		method: 'get',
		params
	})
// 删除信息通知
export const userMessageRemove = (data) =>
	request({
		url: '/api/userMessage/delete/b',
		method: 'post',
		data
	})
// 查询树结构
export const querySendPersion = (params) =>
	request({
		url: '/api/userMessage/querySendPersion',
		method: 'get',
		params
	})
export const userMessageSend = (data) =>
	request({
		url: '/api/userMessage',
		method: 'post',
		data
	})
// 模板
export const templateCode = (params) =>
	request({
		url: '/api/templateCode',
		method: 'get',
		params
	})
// 获取验证码
export const code = () =>
	request({
		url: '/auth/code',
		method: 'get'
	})
// 获取验证码c端
export const codeC = () =>
	request({
		url: '/auth/code/c',
		method: 'get'
	})
// 验证码登录获取验证码
export const getCode = (data) =>
	request({
		url: '/auth/getPhoneCode/c',
		method: 'post',
		data
	})
// 登录
export const login = (data) =>
	request({
		url: '/auth/login',
		method: 'post',
		data
	})
// 上传图片
export const pictures = (data) =>
	request({
		url: '/api/localStorage/pictures',
		method: 'post',
		data
	})
// c端登陆
export const login_c = (data) =>
	request({
		url: '/user/auth/login/c',
		method: 'post',
		data
	})
// c端注册
export const register_c = (data) =>
	request({
		url: '/user/auth/register/c',
		method: 'post',
		data
	})
//  获取手机验证码
export const mobileCode = (params) =>
	request({
		url: '/auth/mobileCode',
		method: 'get',
		params
	})
// b端找回密码
export const forgotPassword_b = (data) =>
	request({
		url: '/user/auth/forgotPassword/b',
		method: 'post',
		data
	})
// c端找回密码
export const forgotPassword_c = (data) =>
	request({
		url: '/user/auth/next/c',
		method: 'post',
		data
	})
// c端我的比赛
export const queryOnePerson_c = (params) =>
	request({
		url: '/api/userMatchBasic/queryOnePerson/c',
		method: 'get',
		params
	})
// c端修改密码
export const updatePass_c = (data) =>
	request({
		url: '/api/users/updatePass/c',
		method: 'post',
		data
	})
// c端信息通知
export const queryHasRead_c = (params) =>
	request({
		url: '/api/userMessage/queryUnreadMsg/c',
		method: 'get',
		params
	})
// c端我的比赛查看
export const getMatchById_c = (params) =>
	request({
		url: '/api/userMatchBasic/getMatchById/c',
		method: 'get',
		params
	})
// c端日志查看
export const queryLog_c = (params) =>
	request({
		url: '/api/userMatchLog/queryLog/c',
		method: 'get',
		params
	})
// c端删除
export const delete_c = (data) =>
	request({
		url: '/api/userMatchBasic/delete/c',
		method: 'delete',
		data
	})
// 大赛报名
export const create_c = (data) =>
	request({
		url: '/api/userMatchBasic/create/c',
		method: 'post',
		data
	})
// c端撤回
export const withdraw_c = (data) =>
	request({
		url: '/api/userMatchBasic/withdraw/c',
		method: 'put',
		data
	})
// c端下载模板
export const downloadTemplate_c = (params) =>
	request({
		url: 'api/userMatchBasic/downloadTemplate/c',
		method: 'get',
		responseType: 'blob',
		params
	})
// c端修改报名信息
export const update_c = (data) =>
	request({
		url: '/api/userMatchBasic/update/c',
		method: 'put',
		data
	})
// c端查看信息详情
export const findByMessageId_c = (params) =>
	request({
		url: '/api/userMessage/findMsgById/c',
		method: 'get',
		params
	})
// c端信息列表
export const queryPersonMessage_c = (params) =>
	request({
		url: '/api/userMessage/queryPersonMsg/c',
		method: 'get',
		params
	})
// c端上传文件
export const localStorage_c = (data) =>
	request({
		url: '/api/localStorage/c',
		method: 'post',
		data
	})
// 学院列表
export const dictDetail_c = (params) =>
	request({
		url: '/api/dictDetail/c',
		method: 'get',
		params
	})
// 成果展示
export const userAchievement_c = (params) =>
	request({
		url: '/api/userAchievement/home/c',
		method: 'get',
		params
	})
// c端补充材料
export const userMatchSupplement_c = (data) =>
	request({
		url: '/api/userMatchSupplement/create/c',
		method: 'post',
		data
	})

export const userMediaReports_c = (params) =>
	request({
		url: '/api/userAchievement/home/c',
		method: 'get',
		params
	})
// 手机验证码登录
export const loginbycode = (params) =>
	request({
		url: '/user/auth/loginbycode',
		method: 'post',
		params
	})
// 查询角色列表
export const getRoles = (params) =>
	request({
		url: '/api/roles',
		method: 'get',
		params
	})
// 新增角色
export const addRoles = (data) =>
	request({
		url: '/api/roles',
		method: 'post',
		data
	})
// 编辑角色
export const editRoles = (data) =>
	request({
		url: '/api/roles',
		method: 'put',
		data
	})
// 删除角色
export const deleteRoles = (data) =>
	request({
		url: '/api/roles',
		method: 'delete',
		data
	})
// 查询角色权限树
export const roleAuthority = (params) =>
	request({
		url: '/api/roleAuthority/tree',
		method: 'get',
		params
	})
//轮播图列表
export const getCarouselFigureByPage = (params) =>
	request({
		url: '/api/carouseFigure/getCarouselFigureByPage',
		method: 'get',
		params
	})
//添加轮播图
export const addCarouselFigure = (data) =>
	request({
		url: '/api/carouseFigure/addCarouselFigure',
		method: 'post',
		data
	})
//修改轮播图
export const updateCarouselFigure = (data) =>
	request({
		url: '/api/carouseFigure/updateCarouselFigure',
		method: 'post',
		data
	})
//启用，禁用，删除轮播图
export const updateCarouselFigureStatus = (data) =>
	request({
		url: '/api/carouseFigure/updateCarouselFigureStatus',
		method: 'post',
		data
	})
// 实名认证用户列表
export const getUserAutonym = (params) =>
	request({
		url: '/api/users/getUserAutonym',
		method: 'get',
		params
	})
// 审核接口
export const auditUser = (params) =>
	request({
		url: '/api/users/auditUser',
		method: 'get',
		params
	})
// 查询部门树
export const queryDept = () =>
	request({
		url: '/api/dept/tree/noPage',
		method: 'get'
	})
//实名认证
export const autonym_c = (data) =>
	request({
		url: '/api/users/autonym/c',
		method: 'post',
		data
	})
//消息批量操作
export const batchMsg_c = (data) =>
	request({
		url: '/api/userMessage/batchMsg/c',
		method: 'post',
		data
	})
//我得帖子
export const postForum_c = (params) =>
	request({
		url: '/api/postForum/c',
		method: 'get',
		params
	})
//我得回复
export const getCommentInfoByUserId_c = (params) =>
	request({
		url: '/api/postForumComment/getCommentInfoByUserId/c',
		method: 'get',
		params
	})
//删除帖子
export const postForumDelete = (data) =>
	request({
		url: '/api/postForum/c',
		method: 'delete',
		data
	})
//比赛
export const searchMatchByUserId_c = (params) =>
	request({
		url: '/api/match/searchMatchByUserId/c',
		method: 'get',
		params
	})

//团队
export const getMyTeam_c = (params) =>
	request({
		url: '/api/team/getMyTeam/c',
		method: 'get',
		params
	})
//大赛资讯详情
export const getComptitionInformationById_c = (params) =>
	request({
		url: '/api/competitionInformation/getComptitionInformationById/c',
		method: 'get',
		params
	})
//大赛资讯liebiao
export const getComptitionInformationByPage_c = (params) =>
	request({
		url: '/api/competitionInformation/getComptitionInformationByPage/c',
		method: 'get',
		params
	})
//  c端验证验证码
export const getPhoneCode = (data) =>
	request({
		url: '/auth/getPhoneCode/c',
		method: 'post',
		data
	})

//  c端密码重置
export const resetPwd = (data) =>
	request({
		url: '/user/auth/resetPwd/c',
		method: 'post',
		data
	})
// c端修改头像
export const updateAvatar = (data) =>
	request({
		url: '/api/users/updateAvatar/c',
		method: 'post',
		data
	})
// 获取当前用户登录信息
export const getUserInfo = (data) =>
	request({
		url: '/auth/info/c',
		method: 'get',
		data
	})
//
export const updateEmailAndNickName = (data) =>
	request({
		url: '/api/users/updateEmailAndNickName/c',
		method: 'post',
		data
	})
